import '../services.css'; 

const WebDevelopment = () => {
  return (
    <div className="cover w-100">
      {/* Hero Section */}
      <div className="service-hero-section text-white py-5 text-center bg-primary">
        <h1 className="display-4 fw-bold mb-3">Website Development</h1>

      </div>

      {/* Web Development Section */}
      <div className="container py-5">
        <div className="row align-items-center">
          {/* Left - Text */}
          <div className="col-md-8 mb-4 mb-md-0">
            <h2 className="h3 fw-semibold mb-4">Web Development</h2>
            <p className="text-justify">
              Make your visions a reality! The backbone of a website is web development. It is what allows the website to work. It all comes down to how the website functions and how potential buyers navigate through it. Web programming, commonly referred to as web development, is the process of creating dynamic web applications. It develops the website using a variety of web languages and software tools.
            </p>
            <p className="text-justify">
              You may think, what makes Panorama stand out from its competitors? We take in delivering your vision through our technique! Choosing the correct Web development firm can make a big difference. It aids in the rise of relevant search traffic to websites and ensures that it benefits your company.
            </p>
            <p className="text-justify">
              Our services are simple and focused on the larger goal of your company's success. To construct the most appropriate site, we discuss, plan, and understand your business needs!
            </p>
            <p className="text-justify">
              Our company specializes in completing projects with great correctness and matching your business needs. The sky's the limit with our skilled web developers. Everything from a simple content website to the most complex E-commerce website is covered by our web development services.
            </p>
            <p className="text-justify">
              Our web development firm uses technologies such as React, Angular, Node js, PHP, and Java to create user-friendly and practical solutions for managing your company's documentation, processes, and workflows. We have a development team dedicated solely to front-end development, which encompasses HTML5, javascript, responsive web, and so on.
            </p>
          </div>

          {/* Right - Image */}
          <div className="image-area col-md-4 text-center text-md-end h-100">
            <img
              src="assets\images\service\webDev\web_bubble.jpg"
              alt="Web Development"
              className="img-fluid rounded shadow"
              style={{ width: '100%', height:'auto', objectFit: 'contain' }}
            />
          </div>
        </div>
      </div>

      {/* Additional Sections */}
      <div className="container py-5  ">
        {/* Unique Web Design */}
        <div className="mb-5">
          <h3 className="h4 fw-semibold mb-3">Web Design That Is Unique</h3>
          <p className="text-justify">
            Before creating a website design for a client or business, we make certain that we understand their specific needs.
            Every website we create is personalized to meet your customers' expectations and to match your brand's image as closely as possible for consistency.
          </p>
        </div>

        {/* Responsive Web Design */}
        <div className="mb-5">
          <h3 className="h4 fw-semibold mb-3">Responsive Web Design</h3>
          <p className="text-justify">
            Our specialization is creating responsive web design that combines aesthetics and functionality to create seamless experiences across a variety of devices.
            Our designs are sleek, eye-catching, and intuitive, precisely fitting all screen sizes to impress users at first glance.
          </p>
        </div>

        {/* Landing Page Design */}
        <div className="mb-5">
          <h3 className="h4 fw-semibold mb-3">Designing A Landing Page</h3>
          <p className="text-justify">
            Our team includes skilled landing page designers who can create stunning landing pages.
            We ensure that the pages are visually appealing and contain all of the features necessary to make an impression and retain client interest.
          </p>
        </div>

        {/* Copywriting */}
        <div className="mb-4">
          <h3 className="h4 fw-semibold mb-3">Copywriting</h3>
          <p className="text-justify">
            We work on the content as well as the appearance of the websites.
            Our main goal is to tell engaging stories with a natural balance of text and graphics.
            At the same time, our copywriters ensure that the material matches the tone of voice of your company.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WebDevelopment;
